export default [
    {
        title: 'TABLEAU DE BORD',
        route: 'supervisor-dashboard',
        action: 'page',
        resource: 'supervisor-dashboard',
        icon: 'PieChartIcon',
    },
    {
        title: 'COMMANDES PORTAIL',
        route: 'supervisor-portal-orders',
        action: 'page',
        resource: 'supervisor-portal-orders',
        icon: 'ShoppingCartIcon',
    },
    {
        header: 'UTILISATEURS',
        icon: 'UsersIcon',
        children: [
            {
                title: 'PHARMACIES',
                route: 'supervisor-pharmacy',
                action: 'page',
                resource: 'supervisor-pharmacy',
                icon: 'BriefcaseIcon',
            },
            {
                title: 'FOURNISSEURS',
                route: 'supervisor-vendor',
                action: 'page',
                resource: 'supervisor-vendor',
                icon: 'TruckIcon',
            },
        ],
    },
    {
        header: 'ARTICLES',
        icon: 'ClipboardIcon',
        children: [
            {
                title: 'ARTICLES',
                route: 'supervisor-item-list',
                icon: 'GridIcon',
                action: 'page',
                resource: 'supervisor-item-list',
            },
            {
                title: 'DCI',
                route: 'supervisor-dci',
                icon: 'GridIcon',
                action: 'page',
                resource: 'supervisor-dci',
            },
            {
                title: 'FAMILLES',
                route: 'supervisor-family',
                icon: 'GridIcon',
                action: 'page',
                resource: 'supervisor-family',
            },
            {
                title: 'SOUS-FAMILLES',
                route: 'supervisor-subFamily',
                icon: 'GridIcon',
                action: 'page',
                resource: 'supervisor-subFamily',
            },
        ],
    },
    {
        header: 'SUIVI',
        icon: 'ActivityIcon',
        children: [
            {
                title: 'RÉCLAMATIONS',
                route: 'supervisor-claims',
                action: 'page',
                resource: 'supervisor-claims',
                icon: 'MessageSquareIcon',
            },
            {
                title: 'SUIVI CONNEXIONS',
                route: 'supervisor-connection-tracking',
                action: 'page',
                resource: 'supervisor-connection-tracking',
                icon: 'ActivityIcon',
            },
            {
                title: 'JOURNAUX MIDDLEWARE',
                route: 'supervisor-middleware-logs',
                action: 'page',
                resource: 'supervisor-middleware-logs',
                icon: 'DatabaseIcon',
            },
        ],
    },
    {
        header: 'SITE WEB',
        icon: 'ImageIcon',
        children: [
            {
                title: 'Demandes Devenir client',
                route: 'supervisor-vitrine-prospects',
                icon: 'UserPlusIcon',
                action: 'page',
                resource: 'supervisor-website-contact',
            },
            {
                title: 'Candidatures',
                route: 'supervisor-vitrine-candidatures',
                icon: 'FileTextIcon',
                action: 'page',
                resource: 'supervisor-website-contact',
            },
        ],
    },
]
